import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
//import Restaurant from './pages/Restaurant'; /*Pagina Ristorante ufficiale per quando sarà aperto il ristorante */
import ComingSoonRestaurant from './pages/ComingSoonRestaurant'; // Aggiungere questa riga
import Farm from './pages/Farm';
//import Products from './pages/Products';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col">
        <Header />
        <motion.main 
          className="flex-grow"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            {/*<Route path="/ristorante" element={<Restaurant />} /> */} {/*Pagina Ristorante ufficiale per quando sarà aperto il ristorante */}
            <Route path="/ristorante" element={<ComingSoonRestaurant />} />
            <Route path="/azienda-agricola" element={<Farm />} />
            {/*<Route path="/prodotti" element={<Products />} /> */}
            <Route path="/contatti" element={<Contact />} />
          </Routes>
        </motion.main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
